import { UMButton, UMR, UMStack } from '../../../urbanmap/_components';
import { NJText } from '@engie-group/fluid-design-system-react';
import type { useDensity } from './useDensity';

export function DensityControls({ density: d, blocked }: { density: ReturnType<typeof useDensity>; blocked: boolean }) {
  return <UMStack>
    <UMButton disabled={blocked || d.loading || !d.canCalculate} onClick={d.calculate}>
      <span style={{ whiteSpace: 'normal', maxWidth: 190 }}>Calculer la densité linéaire</span>
    </UMButton>
    <div role="status" aria-live="polite" style={{ fontSize: 12, color: UMR.textMuted }}>
      {d.loading && <div>Calcul simulé en cours…</div>}
      {d.error && <div role="alert">{d.error}</div>}
      {d.unavailable && <NJText scale="sm">{d.unavailable}</NJText>}
      {d.result && !d.loading && <div aria-label="Résultat de densité linéaire">
        Densité moyenne simulée : {d.result.value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })} MWhu/m
        {d.stale && ' (à recalculer)'}
      </div>}
    </div>
    {d.loading && <UMButton variant="secondary" onClick={d.cancel}>Annuler le calcul de densité</UMButton>}
  </UMStack>;
}
